export default __webpack_public_path__ + "static/media/overzicht.67e98eac.jpg";